import React from "react"
import CalendarTutorial from "../../components/calendar-tutorial"

const tutorial = {
  title: "Lock Your Calendar to a Weekly View",
  description:
    "Turn on the weekly calendar setting to hide dates and navigation, keep a weekly timetable in view, and share it with families.",
  intro:
    "Keep a classroom timetable, practice routine, or after-school plan on one weekly view. The weekly calendar setting shows weekday names without dates and hides the controls for navigating between weeks.",
  rows: [],
  prompt: "",
  steps: [
    {
      title: "1. Open the week you want to keep",
      paragraphs: [
        "On a desktop browser, open the calendar you want to use, select Week in the toolbar, and navigate to the week containing your timetable. Check that the activities and times are correct before enabling the weekly setting, because it hides the week-navigation controls.",
        "For example, choose the week containing your usual Monday reading lesson, Wednesday sport, and Friday music practice. Those sessions will become the weekly timetable you keep in view.",
      ],
    },
    {
      title: "2. Open Calendar Settings",
      paragraphs: [
        "Select the calendar’s settings button with the cog icon. In Calendar Settings, find the checkbox labelled “Is a weekly calendar?”.",
      ],
    },
    {
      title: "3. Enable the weekly calendar setting",
      paragraphs: [
        "Check “Is a weekly calendar?” and select Save Changes. The calendar shows weekday names without dates and hides the navigation toolbar.",
        "Enabling this setting also unchecks and disables “Always open this calendar at today's date”. This lets your saved timetable stay in view instead of opening on the current date.",
      ],
    },
    {
      title: "4. Check your weekly timetable",
      paragraphs: [
        "Check that the intended activities are visible under the correct weekdays. You can still edit events in your own calendar while the weekly setting is enabled.",
        "On phones, the editor opens in a day view and shared calendars open in an agenda view. The weekly setting does not force those layouts into a seven-day grid. Use a desktop browser for the full weekly timetable.",
        "The setting changes the calendar display; it does not create repeating events or copy sessions into future weeks. Use it when you want to present a regular weekly routine.",
      ],
    },
    {
      title: "5. Share the weekly view",
      paragraphs: [
        "To share the timetable, select Publish calendar and publish it. If the calendar is already published, select Republish to update the shared version with your new setting.",
        "Open the published link in another browser or on your phone. On desktop, check that it shows the expected week, weekday names without dates, and no week-navigation toolbar. On a phone, check that the agenda displays the intended sessions. The published calendar remains read-only.",
      ],
    },
    {
      title: "6. Restore dates and week navigation",
      paragraphs: [
        "Open Calendar Settings again, uncheck “Is a weekly calendar?”, and select Save Changes. Dates and the navigation toolbar return, so you can choose another week.",
        "If you also want the calendar to open on the current date, check “Always open this calendar at today's date” before saving. Turning off the weekly setting does not automatically turn that option back on.",
        "To keep a different week in view, navigate to it and enable the weekly setting again. Republish if you want your shared calendar to reflect the change.",
      ],
    },
  ],
  cta: "Set up your weekly calendar",
  relatedUrl: "/how-to-guides/publish-share-calendar/",
  relatedTitle: "Publish and Share Your Calendar",
}

export default function GuidePage() {
  return <CalendarTutorial {...tutorial} />
}
